import { render, staticRenderFns } from "./BotAuth.vue?vue&type=template&id=3f0040e1"
import script from "./BotAuth.vue?vue&type=script&lang=js"
export * from "./BotAuth.vue?vue&type=script&lang=js"
import style0 from "./BotAuth.vue?vue&type=style&index=0&id=3f0040e1&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports